<template>
	<section class="container">
		<h2 class="typo-h1 mb-8">
			{{ blok.heading }}
		</h2>

		<div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
			<StoryblokComponent v-for="item in blok.tiles" :key="item._uid" :blok="item" />
		</div>
	</section>
</template>

<script setup lang="ts">
	import type {FollowUpTilesStoryblok} from '@/storyblok/types';

	type Props = {
		blok: FollowUpTilesStoryblok;
	};

	defineProps<Props>();
</script>
